import { render, staticRenderFns } from "./StructuralPlateTable.vue?vue&type=template&id=74547bc9"
import script from "./StructuralPlateTable.vue?vue&type=script&lang=ts"
export * from "./StructuralPlateTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74547bc9')) {
      api.createRecord('74547bc9', component.options)
    } else {
      api.reload('74547bc9', component.options)
    }
    module.hot.accept("./StructuralPlateTable.vue?vue&type=template&id=74547bc9", function () {
      api.rerender('74547bc9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Viewer/Info/StructuralPlateTable.vue"
export default component.exports